import FluxUtils from 'flux/utils';

import { FilterMode } from 'sharedreact/constants/generic/Constants';
import Filter from 'sharedreact/data/Filter';
import SettingsStore from 'sharedreact/stores/SettingsStore';
import { assertNonNullish } from 'sharedreact/utils/TypeSupport';

import AuditActions from 'workspaces/launcher/actions/AuditActions';
import AuditTab from 'workspaces/launcher/components/admin/AuditTab';
import AuditStore from 'workspaces/launcher/stores/AuditStore';
import asFunctional from 'sharedreact/components/asFunctional';

type Props = {
  index: number,
  activeTab: number,
};

type State = ConstructorParameters<typeof AuditTab>[0];

function getStores () {
  return [
    SettingsStore,
    AuditStore
  ];
}

function handleLoad () {
  // AuditActions.fetch();
}

function handleSetFilter (filterString: string): void {
  AuditActions.setFilter(
    FilterMode.GALLERY,
    Filter.createFromString(filterString, AuditStore.getFilterKeywords()),
    filterString);

  AuditActions.activateFilter(FilterMode.GALLERY);
}

function calculateState (prevState?: State, props?: Props): State {
  assertNonNullish(props);

  return {
    index: props.index,
    activeTab: props.activeTab,
    language: SettingsStore.getLanguage(),
    auditRecords: AuditStore.getItems(),
    sortOrder: AuditStore.getSortOrder(),
    onSortOrderChange: AuditActions.setSortOrder,
    onLoad: handleLoad,
    isFetching: AuditStore.isFetching(),
    filter: AuditStore.getFilterString(),
    filterKeywords: AuditStore.getFilterKeywords(),
    setVisibleRange: AuditActions.setVisibleRange,
    setFilter: handleSetFilter,
    onRefresh:AuditActions.refresh,
  };
}

export default FluxUtils.Container.createFunctional(
  asFunctional(AuditTab),
  getStores,
  calculateState,
  { withProps: true }
);
